export const REACH_EN = {
    'account.channels': 'How you are told',
    'account.channels.lede': 'The channels this workspace sends notifications on, and your own choice for each. The bell in the app is always kept: it is the record of what you were told.',
    'account.channels.name.in_app': 'In the app',
    'account.channels.name.email': 'Email',
    'account.channels.name.whatsapp': 'WhatsApp',
    'account.channels.name.sms': 'Text message (SMS)',
    'account.channels.always': 'Always on',
    'account.channels.on': 'On',
    'account.channels.off': 'Off',
    'account.channels.fixed': 'Everything you are told reaches the bell at the top of the page.',
    'account.channels.defaultOn': 'On until you switch it off.',
    'account.channels.defaultOff': 'Off until you switch it on.',
    'account.channels.changed': 'Your choice, since {date}.',
    'account.channels.noAddress': 'No email address is known for your sign-in, so nothing can be sent there.',
    'account.channels.whatsapp.given': 'You agreed on {date} to be told on WhatsApp.',
    'account.channels.whatsapp.withdrawn': 'You withdrew your agreement on {date}. Nothing is sent to you on WhatsApp.',
    'account.channels.whatsapp.never': 'Nothing is sent to you on WhatsApp until you agree to it.',
    'account.channels.whatsapp.noPerson': 'Your sign-in here is not linked to a person on the register, so there is nobody to ask. HR links it.',
    'account.channels.whatsapp.number': 'Messages go to the mobile number on your record with HR, and carry a notice, a date and a link into the app — never a name or an amount.',
    'account.channels.whatsapp.give': 'Agree to WhatsApp',
    'account.channels.whatsapp.withdraw': 'Withdraw agreement',
    // My notifications: mute one notice on one channel (0060).
    'account.preferences': 'My notifications',
    'account.preferences.lede': 'The notices that can reach you, by where they come from. Switch a channel off to stop that notice there; everything else stays as it is. A notice marked «Always sent» reaches you whatever you choose.',
    'account.preferences.empty': 'No notice in this workspace reaches you yet.',
    'account.preferences.mandatory': 'Always sent',
    'account.preferences.channelOn': '{channel}: on',
    'account.preferences.channelOff': '{channel}: muted',
    'account.preferences.mutedCount': '{n} muted',
    'notifications.preferences': 'Choose what reaches you',
    'notifications.refusal.preferences.rule': 'No notice that can reach you has this key.',
    'notifications.refusal.preferences.channel': 'This notice does not reach you on that channel.',
    'notifications.refusal.preferences.choice': 'Say whether it is muted: yes or no.',
    'notifications.refusal.preferences.mandatory': 'This notice is always sent: it cannot be muted.',
};
export const REACH_AR = {
    'account.channels': 'كيف تصلك التنبيهات',
    'account.channels.lede': 'القنوات التي ترسل عليها مساحة العمل هذه تنبيهاتها، واختيارك في كلٍّ منها. الجرس في التطبيق باقٍ دائماً: فهو سجلّ ما بُلِّغتَ به.',
    'account.channels.name.in_app': 'داخل التطبيق',
    'account.channels.name.email': 'البريد الإلكتروني',
    'account.channels.name.whatsapp': 'واتساب',
    'account.channels.name.sms': 'رسالة نصية (SMS)',
    'account.channels.always': 'مفعّلة دائماً',
    'account.channels.on': 'مفعّلة',
    'account.channels.off': 'متوقّفة',
    'account.channels.fixed': 'كل ما تُبلَّغ به يصل إلى الجرس أعلى الصفحة.',
    'account.channels.defaultOn': 'مفعّلة حتى توقفها.',
    'account.channels.defaultOff': 'متوقّفة حتى تفعّلها.',
    'account.channels.changed': 'اختيارك، منذ {date}.',
    'account.channels.noAddress': 'لا عنوان بريد معروف لدخولك، فلا يُرسَل إليه شيء.',
    'account.channels.whatsapp.given': 'وافقتَ بتاريخ {date} على تبليغك عبر واتساب.',
    'account.channels.whatsapp.withdrawn': 'سحبتَ موافقتك بتاريخ {date}. لا يُرسَل إليك شيء عبر واتساب.',
    'account.channels.whatsapp.never': 'لا يُرسَل إليك شيء عبر واتساب حتى توافق.',
    'account.channels.whatsapp.noPerson': 'دخولك هنا غير مربوط بشخص في السجل، فلا أحد يُسأل عن موافقته. تربطه الموارد البشرية.',
    'account.channels.whatsapp.number': 'تُرسَل الرسائل إلى رقم الجوال المسجّل لك لدى الموارد البشرية، وتحمل تنبيهاً وتاريخاً ورابطاً إلى التطبيق — لا اسماً ولا مبلغاً.',
    'account.channels.whatsapp.give': 'أوافق على واتساب',
    'account.channels.whatsapp.withdraw': 'سحب الموافقة',
    'account.preferences': 'تنبيهاتي',
    'account.preferences.lede': 'التنبيهات التي قد تصلك، مرتّبة بحسب مصدرها. أوقف قناةً لتكفّ عن تلقّي ذلك التنبيه عليها، ويبقى ما سواه كما هو. التنبيه الموسوم «يُرسَل دائماً» يصلك أيّاً كان اختيارك.',
    'account.preferences.empty': 'لا تنبيه في مساحة العمل هذه يصلك بعد.',
    'account.preferences.mandatory': 'يُرسَل دائماً',
    'account.preferences.channelOn': '{channel}: مفعّل',
    'account.preferences.channelOff': '{channel}: مكتوم',
    'account.preferences.mutedCount': '{n} مكتوم',
    'notifications.preferences': 'اختر ما يصلك',
    'notifications.refusal.preferences.rule': 'لا تنبيه يصلك بهذا المفتاح.',
    'notifications.refusal.preferences.channel': 'هذا التنبيه لا يصلك على تلك القناة.',
    'notifications.refusal.preferences.choice': 'حدّد هل هو مكتوم: نعم أو لا.',
    'notifications.refusal.preferences.mandatory': 'هذا التنبيه يُرسَل دائماً: لا يمكن كتمه.',
};
//# sourceMappingURL=i18n-reach.js.map